// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3lBHe","inner":"Footer_inner__2EgEC","nextIcon":"Footer_nextIcon__15iA4","innerLeft":"Footer_innerLeft__3L0DE"};